import OTPInput from "react-otp-input"

const AUTHENTICATOR_CODE_LENGTH = 6
const RECOVERY_CODE_LENGTH = 8

interface OTPInputProps {
	value: string
	onChange: (value: string) => void
	type: "recovery" | "authenticator"
	shouldAutoFocus?: boolean
}

const OtpInput = ({ value, onChange, type, shouldAutoFocus }: OTPInputProps) => {
	return (
		<OTPInput
			value={value}
			onChange={onChange}
			numInputs={type === "authenticator" ? AUTHENTICATOR_CODE_LENGTH : RECOVERY_CODE_LENGTH}
			inputType="text"
			containerStyle={{ gap: 8 }}
			renderInput={(props) => (
				<input
					{...props}
					className="form-control text-center fs-4"
					style={{ height: 60, width: "100%", maxWidth: 60 }}
					inputMode={type === "recovery" ? "text" : "numeric"}
				/>
			)}
			shouldAutoFocus={shouldAutoFocus}
		/>
	)
}

export default OtpInput
